exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".query-selector .menu-divider {\n  margin-right: 10px;\n  width: 1px;\n  background-color: #ccc;\n  height: 70%;\n  float: right; }\n\n.query-selector .toggle-menu-btn {\n  margin-left: 8px;\n  margin-top: -7px;\n  width: 450px;\n  height: 60px !important;\n  border-color: #ccc;\n  text-align: left !important; }\n  .query-selector .toggle-menu-btn #date-range-picker {\n    display: block;\n    height: 10px; }\n\n.publicationTabs .ant-tabs-tab {\n  margin-top: 15px;\n  height: 30px;\n  padding: 0px;\n  width: 100px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/common/components/QuerySelector/Selector/style.scss
// module id = 1027
// module chunks = 0